<template>
  <div class="wrp">
    <LeadList></LeadList>
  </div>
</template>

<script>
import LeadList from "../components/Main/LeadList";
export default {
  components: {
    LeadList
  },
  data() {
    return {
    };
  },
  created() {
    document.title = "名單列表";
  },
  methods: {
  }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/MobileLeadListView.vue